export const MESSAGE_LEVELS = ['error', 'warning', ''];
export const INPUT_TYPES = ['text', 'password', 'email'];
export const INPUT_MODES = ['text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url', ''];